import { hasWindow } from "@omni/utils/dom.utils";

import {
    PureAemComponent,
    registerComponent
} from "@/components/pureAemComponent";

import "./featureList.scss";

class FeatureList extends PureAemComponent {
    overflowListElements: NodeListOf<Element>;
    moreButton: HTMLElement | null;
    lessButton: HTMLElement | null;

    constructor(element: HTMLElement) {
        super(element);
        this.overflowListElements = element.querySelectorAll(
            ".js-product-features__list--overflow"
        );
        this.moreButton = element.querySelector(
            ".js-product-feature-list__link--more"
        );
        this.lessButton = element.querySelector(
            ".js-product-feature-list__link--less"
        );

        this.init();
    }

    init() {
        this.bindEventHandlers();
    }

    /**
     * Bind the event handlers to the functions
     */
    bindEventHandlers() {
        this.moreButton?.addEventListener(
            "click",
            this.showOverflowList.bind(this)
        );
        this.lessButton?.addEventListener(
            "click",
            this.hideOverflowList.bind(this)
        );
    }

    /**
     * Show the original text and unwatch the wrapper
     * - Switch the visibility link buttons
     * @param e
     */
    showOverflowList(e: Event) {
        e.preventDefault();
        this.moreButton?.classList.add("d-none", "tw:hidden");
        this.lessButton?.classList.remove("d-none", "tw:hidden");
        this.overflowListElements.forEach((el) => {
            el.classList.remove("d-none", "tw:hidden");
        });
    }

    /**
     * Show the preview text and watch the wrapper again
     * - Switch the visibility link buttons
     * @param e
     */
    hideOverflowList(e: Event) {
        e.preventDefault();
        this.moreButton?.classList.remove("d-none", "tw:hidden");
        this.lessButton?.classList.add("d-none", "tw:hidden");
        this.overflowListElements.forEach((el) => {
            el.classList.add("d-none", "tw:hidden");
        });
    }
}
const InitFeatureList = () => {
    hasWindow() && registerComponent(".js-product-features", FeatureList);
};

export { InitFeatureList };
